var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.GeoJsonSource,{attrs:{"data":_setup.props.data,"source-id":"single-point"}},[_c(_setup.LayerGroup,{attrs:{"layers":_setup.layers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }